module.exports = __webpack_public_path__ + "img/360-white.cba53a26.svg";